import React from "react";
import classNames from "classnames";

export default () => Component => {
  const SaveableComponent = props => {
    const divClasses = classNames("ftc-saveable", {});

    if (!props.unsaved) return <Component {...props} />;

    return (
      <div className={divClasses}>
        <i className="fa fa-clock-o" />
      </div>
    );
  };

  return SaveableComponent;
};
